export const LAST_ACTIVE_KEY = 'lastActiveTime';
export const USER_ID = 'userId';
export const USER_EMAIL = 'userEmail';
export const IS_LEFT_FEEDBACK = 'isLeftFeedback';
export const AI_COACH_BANNER_LAST_DISMISSED = 'AI_COACH_BANNER_LAST_DISMISSED';
export const APP_DOWNLOAD_MODAL_SHOWN = 'APP_DOWNLOAD_MODAL_SHOWN';
